
        var result = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/stylus-loader/index.js!./layer-list.component.styl");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/lib/layer/layer-list/layer-list.component.styl
// module id = 1049
// module chunks = 0